
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AvailableLoan } from '@/interfaces/loan';
import MomntIcon from '~/components/Icons/MomntIcon.vue';
import applicationId from '@/filters/application-id';

@Component({ components: { MomntIcon }, filters: { applicationId } })
export default class LoanItem extends Vue {
  @Prop({ type: Object, required: true }) readonly loan!: AvailableLoan;

  onSelect() {
    this.$emit('select', this.loan);
  }

  get isInCollection(): boolean {
    return this.loan.collection?.in_collection;
  }

  get iconName(): string {
    return `program_${this.loan.program.toLowerCase().replaceAll(' ', '_')}`;
  }
}
